import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9358f9a6"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "suggestion-details-period" };
const _hoisted_2 = { class: "section-title" };
const _hoisted_3 = { class: "sdp__active-period-wrapper" };
const _hoisted_4 = { class: "sdp__datepicker-container" };
const _hoisted_5 = { class: "form-group sdp__datepicker element--datepicker" };
const _hoisted_6 = {
    key: 0,
    class: "sdp__datepicker-container__automatic"
};
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "required" }, "*", -1));
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1));
const _hoisted_10 = { class: "sdp__datepicker-container" };
const _hoisted_11 = { class: "sdp__timepicker" };
const _hoisted_12 = { class: "form-group sdp__datepicker element--datepicker" };
const _hoisted_13 = { class: "suggestion-details-period__timepicker" };
const _hoisted_14 = { class: "suggestion-details-period__timepicker" };
const _hoisted_15 = { class: "sdp__timepicker__text" };
const _hoisted_16 = { class: "sdp__days-of-week-wrapper" };
const _hoisted_17 = { class: "label" };
const _hoisted_18 = {
    key: 0,
    class: "sdp__days-of-week-container"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = { class: "sdp__days" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_date_picker = _resolveComponent("el-date-picker");
    const _component_icon_trash = _resolveComponent("icon-trash");
    const _component_icon_base = _resolveComponent("icon-base");
    const _component_el_popover = _resolveComponent("el-popover");
    const _component_el_time_picker = _resolveComponent("el-time-picker");
    const _component_check_box = _resolveComponent("check-box");
    const _directive_tooltip = _resolveDirective("tooltip");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('360.campaigns.details.action-period')), 1),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('360.campaigns.details.active-period')), 1),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.dateValues,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.dateValues) = $event)),
                        type: "daterange",
                        format: "DD MMM YYYY",
                        "value-format": "YYYY-MM-DD",
                        "start-placeholder": _ctx.$tc('start-date'),
                        "end-placeholder": _ctx.$tc('end-date'),
                        clearable: false,
                        "disabled-date": _ctx.disabledBackwardDates,
                        "prefix-icon": _ctx.customPrefix
                    }, null, 8, ["modelValue", "start-placeholder", "end-placeholder", "disabled-date", "prefix-icon"])
                ]),
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", {
                            class: "sdp__icon-container",
                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.deleteActivePeriodDate()))
                        }, [
                            _createVNode(_component_icon_base, {
                                color: '#EC3942',
                                class: "sdp__trash-icon"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_icon_trash)
                                ]),
                                _: 1
                            })
                        ], 512), [
                            [_vShow, (_ctx.startDate && _ctx.endDate) || _ctx.formattedDates]
                        ])
                    ]),
                    _: 1
                })
            ]),
            (_ctx.automaticAction.sendChannel === _ctx.channel.NON_OFFICIAL)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("label", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('360.campaigns.details.send-time')) + " ", 1),
                        _hoisted_7,
                        _createVNode(_component_el_popover, {
                            trigger: "hover",
                            effect: "dark",
                            placement: "top",
                            width: 260,
                            "popper-class": "suggestion-details-period__tooltip"
                        }, {
                            reference: _withCtx(() => [
                                _hoisted_9
                            ]),
                            default: _withCtx(() => [
                                _createElementVNode("p", {
                                    innerHTML: _ctx.$t('360.campaigns.details.limit', { hour: _ctx.getWorkingTime?.end || '18:00' })
                                }, null, 8, _hoisted_8)
                            ]),
                            _: 1
                        })
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                    _createVNode(_component_el_time_picker, {
                                        format: "HH:mm",
                                        "value-format": "HH:mm",
                                        modelValue: _ctx.startHour,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.startHour) = $event)),
                                        placeholder: _ctx.$t('campaigns.start'),
                                        "disabled-hours": _ctx.getDisabledHours,
                                        "disabled-minutes": () => _ctx.makeRange(1, 59),
                                        class: _normalizeClass({ 'suggestion-details-period__timepicker--error': _ctx.invalidHourRange })
                                    }, null, 8, ["modelValue", "placeholder", "disabled-hours", "disabled-minutes", "class"])
                                ]),
                                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createVNode(_component_el_time_picker, {
                                        format: "HH:mm",
                                        "value-format": "HH:mm",
                                        modelValue: _ctx.endHour,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.endHour) = $event)),
                                        placeholder: _ctx.$t('campaigns.end'),
                                        "disabled-hours": _ctx.getDisabledHours,
                                        "disabled-minutes": () => _ctx.makeRange(1, 59),
                                        class: _normalizeClass({ 'suggestion-details-period__timepicker--error': _ctx.invalidHourRange })
                                    }, null, 8, ["modelValue", "placeholder", "disabled-hours", "disabled-minutes", "class"])
                                ])), [
                                    [
                                        _directive_tooltip,
                                        {
                                            theme: 'error',
                                            html: true,
                                            autoHide: false,
                                            distance: 8,
                                            content: _ctx.$t('360.campaigns.details.invalid-hour'),
                                            shown: _ctx.invalidHourRange,
                                        },
                                        void 0,
                                        { right: true }
                                    ]
                                ])
                            ]),
                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('360.campaigns.details.sending-time-text')), 1)
                        ])
                    ])
                ]))
                : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
            _createElementVNode("h2", _hoisted_17, _toDisplayString(_ctx.$t('360.campaigns.details.days-of-week')), 1),
            (_ctx.sentDays)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sentDays, (day) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: day.id,
                            class: "sdp__days-of-week"
                        }, [
                            day
                                ? (_openBlock(), _createElementBlock("label", {
                                    key: 0,
                                    class: "label sdp__checkbox",
                                    onClick: _withModifiers(($event) => (_ctx.$_toggleSelection(day.id, _ctx.campaignCheckedDays)), ["prevent"])
                                }, [
                                    _createVNode(_component_check_box, {
                                        class: "checkbox",
                                        checked: _ctx.$_isSelected(day.id, _ctx.campaignCheckedDays)
                                    }, null, 8, ["checked"]),
                                    _createElementVNode("span", _hoisted_20, _toDisplayString(day.name), 1)
                                ], 8, _hoisted_19))
                                : _createCommentVNode("", true)
                        ]));
                    }), 128))
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
